import { defineStore } from "pinia";
import { features } from '@/mocks/newFeatures';

export const useNewFeaturesStore = defineStore('newFeatures', {
    state: () => ({
        features: features,
    }),

    getters: {
        isNew: (state) => (featureName: string) => {
            const feature = state.features.find(f => f.featureName === featureName)
            if (!feature) return false

            const expirationTime = new Date(feature.expirationDate).getTime()
            const currentTime = new Date().getTime()

            return currentTime <= expirationTime
        }
    }
})